import script from "./Aside.vue?vue&type=script&setup=true&lang=js"
export * from "./Aside.vue?vue&type=script&setup=true&lang=js"

import "./Aside.vue?vue&type=style&index=0&id=3b7ba4ba&scoped=true&lang=css"

import exportComponent from "/Users/ffavreau/www/canton-dans-le-bouillon/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b7ba4ba"]])

export default __exports__